import React from 'react';

import TableHeaderWrapper from '../../../modules/table-header-wrapper/table-header-wrapper';
import { ORDER_DETAILED_STATUS } from '../../../types';
import { getOrderDetailedStatusBadge } from '../../../utils/getStatusBadge';

import './order-realizations-header.scss';

interface OrderRealizationsHeaderProps {
  title: string;
  showStatus?: boolean;
  status: ORDER_DETAILED_STATUS;
  onClose?: () => void;
}

const OrderRealizationsHeader: React.FC<OrderRealizationsHeaderProps> = ({
  title,
  onClose,
  showStatus,
  status,
}) => (
  <TableHeaderWrapper
    isHint
    hintPage="SPECIFICATION_LIST"
    onCloseClick={onClose}
    status={showStatus ? getOrderDetailedStatusBadge(status) : null}
    leftContent={<>{title}</>}
  />
);

export default OrderRealizationsHeader;
